module.exports = __webpack_public_path__ + "static/media/idexpress.538a5a24.png";